// extracted by mini-css-extract-plugin
export default {"filters":"prayerTimes_filters__Szc0k","hijri":"prayerTimes_hijri__Q1SjS","skeletonRows":"prayerTimes_skeletonRows__QbpE3"};